import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CalendarEventForm from '../containers/CalendarEventAdminFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';

class CalendarEventAdminEditScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `CalendarEventAdminEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  trackerActions = (eventMixpanel, params = {}) => {
    if (this.props.role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: this.props.partnershipName ?? 'No partnership',
        partnershipId: this.props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('calendar_event_route_edit')} />
            <CalendarEventForm
              id={this.props.match.params.id}
              trackerActions={this.trackerActions}
            />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
    this.trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.CALENDAR_EVENTS_ADMIN_EDIT_SCREEN
    );
  }
}

export default CalendarEventAdminEditScreen;

Logger.log('silly', `CalendarEventAdminEditScreen loaded.`);
